import { OffersTrackingComponent } from './offers-tracking.component';

import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ offersTracking: OffersTrackingComponent });
